import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class AutenticacionService {

  constructor(private _http: HttpClient) { }

  authorize(access_token: string, cli: string = 'PAdmon', project: string = 'proptech', latitude?: string, longitude?: string): Observable<LoginResponse> {
    let url = 'https://as-ws-zyon-test-keycloak.azurewebsites.net/api/v1/users/authorize';

    const headerObj: any = {
        'cli': cli,
        'project': project,
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${access_token}`
    };
    if (latitude) headerObj.latitude = latitude;
    if (longitude) headerObj.longitude = longitude;

    let headers = new HttpHeaders(headerObj);

    return <Observable<LoginResponse>> this._http.post(url, {
      'deviceidunique':'0'
   }, { headers });
  }

  login(email: string, contrasena: string): Observable<LoginResponse> {
    let url = 'https://login-universal-test.azurewebsites.net/api/auth/login/password';
    let passwordEnc = CryptoJS.SHA256(contrasena).toString(CryptoJS.enc.Hex);

    let headers = new HttpHeaders({
        'loginType': 'username'
    });

    return <Observable<LoginResponse>> this._http.post(url, {
      'email': email,
      'password': contrasena // passwordEn toca ver como resolver lo del hash ua que en el login universal de error, podria usar el header loginType
   }, { headers });
  }

  cerrarSesion() {
    localStorage.removeItem("data_login");
  }

  recuperarContrasena(email: string) {
    const url = "https://as-ws-siteit-test.azurewebsites.net/api/users/recovery";
    
    return <Observable<LoginResponse>> this._http.post(url, {
      email,
   }); 
  }

  cambiarContrasena(contrasena: string, token: string) {
    const url = "https://as-ws-siteit-test.azurewebsites.net/api/users/recovery";
    let passwordEnc = CryptoJS.SHA256(contrasena).toString(CryptoJS.enc.Hex);

    return <Observable<LoginResponse>> this._http.put(url, {
      user_password: passwordEnc,
      token
    }); 
  }

  public get dataLogin(): DataLogin  {
    return JSON.parse(localStorage.getItem('data_login'));
  }
}

export interface LoginResponse {
  data_login: any;
  data: any;
  refresh_token: any;
  access_token: any;
  ok: boolean,
  response: {
    data_login: DataLogin
  },
  message: string
}

export interface DataLogin {
  token: string,
  user_id: number,
  company_id: number,
  company_longitude: string,
  company_latitude: string,
  company_type: number,
  role: string,
  vertical_id: number,
  proptech_type: number,
}